export default __webpack_public_path__ + "assets/images/icon-check-big.f13f669663fce2c7b7881c4002086b1b.svg";